/**
 * encounterIvRange.ts — the wild-encounter HUD's one fact (2026-09-22 owner
 * ask): from the species and the CP on the encounter banner, the IV percent
 * a catch could turn out to be. No HP is printed on that screen, so this is
 * the CP-only solve (ivSolver.solveIvsFromCp) over the wild level window.
 *
 * Memoised on species + CP: the probe re-reads the same banner on every
 * still frame of an encounter.
 */
import { baseStatsForSpecies } from "./generated/speciesBaseStats.generated";
import { solveIvsFromCp, type CpOnlyRange } from "./ivSolver";

export interface EncounterIvRange extends CpOnlyRange {
  /** Whole percents for the HUD ("44" .. "91"). */
  minPercent: number;
  maxPercent: number;
}

const cache = new Map<string, EncounterIvRange | null>();

export function encounterIvRangeFor(speciesId: number, cp: number): EncounterIvRange | null {
  const key = `${speciesId}:${cp}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  const base = baseStatsForSpecies(speciesId);
  let out: EncounterIvRange | null = null;
  if (base && cp >= 10) {
    const r = solveIvsFromCp({ base, cp, encounter: { type: "wild", weatherBoosted: false, trainerLevel: 40 } });
    if (r) {
      out = {
        ...r,
        minPercent: Math.round(r.worstPercent * 100),
        maxPercent: Math.round(r.bestPercent * 100),
      };
    }
  }
  if (cache.size > 200) cache.clear();
  cache.set(key, out);
  return out;
}
